import React from 'react'

const Fifty_one = () => {
    return (
        <div>
            <h1> Check Whether a Number is Palindrome or Not</h1>
            <div className='containers'>
            An integer is a palindrome if the reverse of that number is equal to the original number.
<br /><br />

            </div>
            <div className='containers'>
       <code className='library'>   #include</code>  &lt;stdio.h &gt;<br/>
 <code className='library'>#include</code> &lt;string.h &gt;<br/>

<code className='keywords'>int</code> main()
&#123;<br/>
<code className='keywords'>char</code> a[100], b[100];<br/>

<code className='library'>printf</code>(“Enter the string : “);<br/>
<code className='library'>gets</code>(a);<br/>

<code className='library'>strcpy</code>(b, a);<br/>  <code className='comment'>/* Copying input string */</code><br/>
strrev(b);<br/>  <code className='library'>/* Reversing the string */</code><br/>

<code className='keywords'>if</code>  (strcmp(a, b) == 0) <code className='comment'>/* Comparing input string with the reverse string */</code><br/>
<code className='library'>printf</code>(“The string is a palindrome\n”);<br/>
<code className='keywords'>else</code>
<code className='library'>printf</code>(“The string is not t a palindrome\n”);<br/>

<code className='library'>return</code> 0;<br/>
&#125;<br/>
            </div>
        </div>
    )
}

export default Fifty_one
